import { replaceAntiForgeryToken } from '../../functions/add-antiforgery-token';
import { LoadingIndicator } from './../loading-indicator/loading-indicator';
import { Component } from '@opten/compiler/metadata/component';
import { getStickyOffset } from '../../utilities/scroll-helper';
import { scrollToOffset } from '@opten/scroll/scroll-to-offset';
import { linearTween } from '@opten/animation/linear-tween';
import { removeClass } from '@opten/dom/remove-class';
import { hasClass } from '@opten/dom/has-class';


@Component({ className: 'js-vehicle-storage' })
export class VehicleStorageComponent {

    loadingIndicatorDark: string;
    loadingIndicator: string;
    contentElement: HTMLElement;
    formElementWrapper: HTMLElement;
    leasingCalculatorElement: HTMLElement;
    targetToLoad: string;
    language: string;
    formElement: HTMLFormElement;
    leasingCalculatorTargetToLoad: string;
    leasingCalculatorStartingAtWrapperElements: HTMLElement[];
    leasingCalculatorElementWrapper: HTMLElement;
    leasingCalculatorElementWrapperBg: HTMLElement;
    loadingIndicatorMini: string;
    leasingFormElement: HTMLFormElement;
    formRequestLeasingOffer: HTMLInputElement;
    formLeasingCalculator: HTMLInputElement;
    formLeasingCalculatorRequestLeasingOffer: HTMLElement;

    constructor(private element: HTMLElement) {
        this.loadingIndicatorDark = new LoadingIndicator().contentLoadingDark;
        this.loadingIndicator = new LoadingIndicator().contentLoading;
        this.loadingIndicatorMini = new LoadingIndicator().contentLoadingMini;
        this.contentElement = element;
        this.init();
    }

    init() {
        this.targetToLoad = this.contentElement.getAttribute('data-load');
        var dataLanguage = document.body.getAttribute('data-language-long');
        if (dataLanguage && dataLanguage.length > 0) {
            this.language = dataLanguage;
        }
        this.contentElement.innerHTML = this.loadingIndicatorDark;
        this.handleLoadContent();
        this.restoreBackUrl();
    }

    private restoreBackUrl(): void {
        // Only restore from sessionStorage if backUrl is not already in the URL
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('backUrl') && urlParams.get('backUrl').length > 0) {
            return; // URL already has backUrl parameter, skip sessionStorage restore
        }
        
        const backUrl = sessionStorage.getItem('merbag.vehiclesStorageBackUrl');
        if (backUrl) {
            const backLinks = Array.from(document.getElementsByClassName('js-vehicle-storage-back'));
            backLinks.forEach((link: HTMLAnchorElement) => {
                link.href = decodeURIComponent(backUrl);
            });
        }
    }

    private handleLoadContent(): void {
        fetch(this.targetToLoad, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept-language': this.language,
                // todo: why? if we change to a api controller we don't have this problem...
                'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
            },
            credentials: 'include'
        })
            .then(response => {
                const contentType = response.headers.get('content-type');
                if (contentType && (contentType.includes('text/html') || contentType.includes('text/plain'))) {
                    return response.text();
                }
            })
            .then(data => {
                this.handleDataContentResult(data);
            });
    }

    private handleDataContentResult(data: string) {
        if (data != null && data.length > 0) {
            this.contentElement.innerHTML = data;
            const formElementWrappers = this.contentElement.getElementsByClassName('js-vehicle-storage-form');
            if (formElementWrappers && formElementWrappers.length > 0) {
                this.formElementWrapper = formElementWrappers[0] as HTMLElement;
                this.initializeContentForm();
            }
            const leasingCalculatorElements = this.contentElement.getElementsByClassName('js-vehicle-storage-leasing-calculator');
            if (leasingCalculatorElements && leasingCalculatorElements.length > 0) {
                this.leasingCalculatorElement = leasingCalculatorElements[0] as HTMLElement;
                const leasingCalculatorWrapperElements = document.getElementsByClassName('js-vehicle-storage-leasing-calculator-wrapper');
                if (leasingCalculatorWrapperElements && leasingCalculatorWrapperElements.length > 0) {
                    this.leasingCalculatorElementWrapper = leasingCalculatorWrapperElements[0] as HTMLElement;
                    const leasingCalculatorWrapperBgElements = this.leasingCalculatorElementWrapper.getElementsByClassName('js-vehicle-storage-leasing-calculator-bg');
                    if (leasingCalculatorWrapperBgElements && leasingCalculatorWrapperBgElements.length > 0) {
                        this.leasingCalculatorElementWrapperBg = leasingCalculatorWrapperBgElements[0] as HTMLElement;
                    }
                    this.leasingCalculatorStartingAtWrapperElements = Array.from(this.leasingCalculatorElementWrapper.getElementsByClassName('js-vehicle-storage-leasing-starting-at-wrapper')) as HTMLElement[];
                }

                this.initializeLeasingCalculator();
            }
        }
    }
    private initializeLeasingCalculator() {
        if (this.leasingCalculatorElementWrapperBg && this.leasingCalculatorStartingAtWrapperElements && this.leasingCalculatorStartingAtWrapperElements.length > 0) {
            const additionalSpacingRequired = this.leasingCalculatorStartingAtWrapperElements[0].getAttribute('data-additional-spacing-required');
            if (additionalSpacingRequired.toLocaleLowerCase() == "true" && !this.leasingCalculatorElementWrapperBg.classList.contains('c-vehicle-storage__background--with-leasing-starting-at')) {
                this.leasingCalculatorElementWrapperBg.classList.add('c-vehicle-storage__background--with-leasing-starting-at');
            }
        }
        const leasingForms = this.leasingCalculatorElement.getElementsByClassName('js-vehicle-storage-leasing-calculator-form');
        if (leasingForms && leasingForms.length > 0) {
            this.leasingFormElement = leasingForms[0] as HTMLFormElement;

            this.handleSubmitLeasingForm(null, true);
        }
    }

    private initializeRequestLeasingOfferButton() {
        const leasingResults = this.leasingCalculatorElement.getElementsByClassName('js-vehicle-storage-leasing-calculator-result');
        if (leasingResults && leasingResults.length > 0) {
            var leasingResult = leasingResults[0] as HTMLElement;
            this.formLeasingCalculatorRequestLeasingOffer = leasingResult.getElementsByClassName('js-vehicle-storage-leasing-calculator-request-offer').length > 0 ? leasingResult.getElementsByClassName('js-vehicle-storage-leasing-calculator-request-offer')[0] as HTMLElement : null;
            if (this.formLeasingCalculatorRequestLeasingOffer && this.formRequestLeasingOffer && this.formElement) {
                this.formLeasingCalculatorRequestLeasingOffer.addEventListener('click', (e) => {
                    e.preventDefault();
                    const rect = this.formElement.getBoundingClientRect();
                    this.formRequestLeasingOffer.checked = true;
                    this.formRequestLeasingOffer.setAttribute('checked', 'checked');
                    scrollToOffset(
                        rect.top,
                        linearTween,
                        50,
                        (getStickyOffset() * -1) - 100
                    );
                });
            }
        }
    }

    private handleDataLeasingCalculatorResult(data: string, isInitialLoad: boolean = false) {
        if (data != null && data.length > 0) {
            this.leasingCalculatorElement.innerHTML = data;
            if (!isInitialLoad) {
                const leasingResults = this.leasingCalculatorElement.getElementsByClassName('js-vehicle-storage-leasing-calculator-result');
                if (leasingResults && leasingResults.length > 0) {
                    var leasingResult = leasingResults[0] as HTMLElement;
                    const rect = leasingResult.getBoundingClientRect();
                    scrollToOffset(
                        rect.top,
                        linearTween,
                        50,
                        (getStickyOffset() * -1) - 50
                    );
                }
            }
            const startingAtSourceElement = this.leasingCalculatorElement.getElementsByClassName('js-vehicle-storage-leasing-starting-at-source');
            if (this.leasingCalculatorStartingAtWrapperElements && this.leasingCalculatorStartingAtWrapperElements.length > 0 && startingAtSourceElement && startingAtSourceElement.length > 0) {
                this.leasingCalculatorStartingAtWrapperElements.forEach(wrapper => {
                    const templateElement = wrapper.getElementsByClassName('js-vehicle-storage-leasing-starting-at-wrapper-template');
                    const contentElement = wrapper.getElementsByClassName('js-vehicle-storage-leasing-starting-at-content');
                    if (templateElement && templateElement.length > 0 && contentElement && contentElement.length > 0) {
                        const templateHtml = (templateElement[0] as HTMLElement).innerHTML;
                        (contentElement[0] as HTMLElement).innerHTML = templateHtml.replace('{0}', startingAtSourceElement[0].innerHTML);
                    }
                });
                if (this.leasingCalculatorElementWrapperBg) {
                    if (!this.leasingCalculatorElementWrapperBg.classList.contains('c-vehicle-storage__background--with-leasing-starting-at')) {
                        this.leasingCalculatorElementWrapperBg.classList.add('c-vehicle-storage__background--with-leasing-starting-at');
                    }
                }
            }
            if (this.formRequestLeasingOffer) {
                removeClass(this.formRequestLeasingOffer.parentElement, 'd-none');
            }
            const leasingForms = this.leasingCalculatorElement.getElementsByClassName('js-vehicle-storage-leasing-calculator-form');
            if (leasingForms && leasingForms.length > 0) {
                this.leasingFormElement = leasingForms[0] as HTMLFormElement;
                var fields = this.leasingFormElement.querySelectorAll('.js-vehicle-storage-leasing-calculator-form-field') ?? [];
                fields.forEach(field => {
                    field.addEventListener('change', (e) => {
                        this.leasingFormElement.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    });
                });
                this.leasingFormElement.addEventListener('submit', (e) => this.handleSubmitLeasingForm(e));
                this.initializeRequestLeasingOfferButton();
            }
        }
        else {
            if( this.leasingCalculatorElement.parentNode ) {
                this.leasingCalculatorElement.parentNode.removeChild(this.leasingCalculatorElement);
            }
            if (this.leasingCalculatorStartingAtWrapperElements && this.leasingCalculatorStartingAtWrapperElements.length > 0) {
                this.leasingCalculatorStartingAtWrapperElements.forEach(wrapper => {
                    if (wrapper.parentNode) {
                        wrapper.parentNode.removeChild(wrapper);
                    }
                });
                if (this.leasingCalculatorElementWrapperBg) {
                    if (this.leasingCalculatorElementWrapperBg.classList.contains('c-vehicle-storage__background--with-leasing-starting-at')) {
                        this.leasingCalculatorElementWrapperBg.classList.remove('c-vehicle-storage__background--with-leasing-starting-at');
                    }
                }
            }
        }
    }

    private handleSubmitLeasingForm(event: Event = null, isInitialLoad: boolean = false) {
        if (event) {
            event.preventDefault();
        }
        if ($(this.leasingFormElement).valid()) {
            replaceAntiForgeryToken(() => {
                // Convert currency fields to numeric values before serialization
                const currencyFields = this.leasingFormElement.querySelectorAll('.js-currency-field');
                currencyFields.forEach((field: HTMLInputElement) => {
                    // Remove formatting and keep only digits
                    const numericValue = field.value.replace(/[^\d]/g, '');
                    field.value = numericValue;
                });
                var formData = $(this.leasingFormElement).serialize();
                this.leasingCalculatorTargetToLoad = this.leasingFormElement.action;
                this.leasingCalculatorElement.innerHTML = this.loadingIndicator;
                // Extract query parameters from this.targetToLoad and append to leasingCalculatorTargetToLoad
                const queryIndex = this.targetToLoad.indexOf('?');
                if (queryIndex !== -1) {
                    const queryParams = this.targetToLoad.substring(queryIndex);
                    formData = queryParams.substring(1) + "&" + formData; // Append query params to form data
                }
                this.leasingCalculatorElement.innerHTML = this.loadingIndicator;
                if (this.leasingCalculatorStartingAtWrapperElements && this.leasingCalculatorStartingAtWrapperElements.length > 0) {
                    this.leasingCalculatorStartingAtWrapperElements.forEach(wrapper => {
                        const contentElement = wrapper.getElementsByClassName('js-vehicle-storage-leasing-starting-at-content');
                        if (contentElement && contentElement.length > 0) {
                            (contentElement[0] as HTMLElement).innerHTML = this.loadingIndicatorMini;
                        }
                    });
                    if (this.leasingCalculatorElementWrapperBg) {
                        if (!this.leasingCalculatorElementWrapperBg.classList.contains('c-vehicle-storage__background--with-leasing-starting-at')) {
                            this.leasingCalculatorElementWrapperBg.classList.add('c-vehicle-storage__background--with-leasing-starting-at');
                        }
                    }
                }
                fetch(this.leasingCalculatorTargetToLoad, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'accept-language': this.language,
                        // todo: why? if we change to a api controller we don't have this problem...
                        'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored,
                    },
                    body: formData,
                    credentials: 'include'
                })
                    .then(response => {
                        const contentType = response.headers.get('content-type');
                        if (contentType && (contentType.includes('text/html') || contentType.includes('text/plain'))) {
                            return response.text();
                        }
                    })
                    .then(data => {
                        this.handleDataLeasingCalculatorResult(data, isInitialLoad)
                    });
            });
        }
    }

    private handleSubmitContentForm(event: Event) {
        event.preventDefault();
        if ($(this.formElement).valid()) {
            this.updateLeasingCalculatorFieldsInContentForm();
            replaceAntiForgeryToken(() => {
                const formData = $(this.formElement).serialize();
                this.formElementWrapper.innerHTML = this.loadingIndicator;
                fetch(this.formElement.action, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'accept-language': this.language,
                        // todo: why? if we change to a api controller we don't have this problem...
                        'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored,
                    },
                    body: formData,
                    credentials: 'include'
                })
                    .then(response => {
                        const contentType = response.headers.get('content-type');
                        const redirected = response.redirected;
                        const url = response.url
                        if (redirected && url) {
                            window.location.href = response.url;
                            throw new Error("redirecting so break out of promise chain.");
                        }
                        if (contentType && (contentType.includes('text/html') || contentType.includes('text/plain'))) {
                            return response.text();
                        }
                    })
                    .then(data => {
                        this.handleDataFormResult(data);
                    });
            });
        }
    }

    private handleDataFormResult(data: string) {
        if (data != null && data.length > 0) {
            this.formElementWrapper.innerHTML = data;
            this.initializeContentForm();
        }
    }

    private initializeContentForm() {
        if (this.formElementWrapper) {
            const formElements = this.formElementWrapper.getElementsByTagName('form');
            if (formElements && formElements.length > 0) {
                this.formElement = formElements[0];
                this.formRequestLeasingOffer = this.formElement.getElementsByClassName('js-vehicle-storage-form-request-leasing-offer').length > 0 ? this.formElement.getElementsByClassName('js-vehicle-storage-form-request-leasing-offer')[0] as HTMLInputElement : null;
                this.formLeasingCalculator = this.formElement.getElementsByClassName('js-vehicle-storage-form-leasing-calculator').length > 0 ? this.formElement.getElementsByClassName('js-vehicle-storage-form-leasing-calculator')[0] as HTMLInputElement : null;


                this.formElement.addEventListener('submit', (e) => this.handleSubmitContentForm(e));

                // extend jquery range validator to work for required checkboxes
                var defaultRangeValidator = $.validator.methods.range;
                $.validator.methods.range = function (value, element, param) {
                    if (element.type === 'checkbox') {
                        // if it's a checkbox return true if it is checked
                        return element.checked;
                    } else {
                        // otherwise run the default validation function
                        return defaultRangeValidator.call(this, value, element, param);
                    }
                }
                $.validator.unobtrusive.parse('form');
            }

        }
    }
    private updateLeasingCalculatorFieldsInContentForm() {
        if (this.formLeasingCalculator && this.leasingFormElement && this.formElement) {
            var calculatorValue = '';
            if (this.formRequestLeasingOffer && this.formRequestLeasingOffer.checked) {
                var calculatorFields = this.leasingFormElement.querySelectorAll('.js-vehicle-storage-leasing-calculator-form-field');
                calculatorFields.forEach((field: HTMLInputElement) => {
                    var fieldValue = field.value;
                    if (hasClass(field, 'js-currency-field')) {
                        fieldValue = field.value.replace(/[^\d]/g, '');
                    }
                    calculatorValue += `${field.name}:${fieldValue};`;
                });
                if (calculatorValue.endsWith(';')) {
                    calculatorValue = calculatorValue.slice(0, -1);
                }
            }
            this.formLeasingCalculator.value = calculatorValue;
        }
    }
}


